import { createReducer, on, Action } from '@ngrx/store';
import { BookingSummary } from '@nx-ng/types';
import { cloneDeep } from 'lodash-es';
import { CheckoutActions } from '../../actions';

export interface IBookingSummaryState {
  bookingSummary?: BookingSummary;
}

export const initialState: IBookingSummaryState = {};

const bookingSummaryReducer = createReducer(
  initialState,
  on(CheckoutActions.saveBookingSummary, (state, { bookingSummary }) => ({
    ...state,
    bookingSummary: cloneDeep(bookingSummary),
  }))
);

export function reducer(
  state: IBookingSummaryState | undefined,
  action: Action
) {
  return bookingSummaryReducer(state, action);
}
